import { useQuery, useQueryClient } from "@tanstack/react-query";

import { getFootprintingCropDryingsByPrimaryDataId, getFootprintingCropDryingsByPrimaryDataIdAdmin } from "services";

import { getEnvironment } from "utils";

import { FOOTPRINTING_CROP_DRYINGS } from "consts";

export const useGetFootprintingCropDryingsByPrimaryDataId = (primaryDataId?: string) => {
  const queryClient = useQueryClient();
  const isAdmin = getEnvironment().admin;

  const queryFn = isAdmin ? getFootprintingCropDryingsByPrimaryDataIdAdmin : getFootprintingCropDryingsByPrimaryDataId;

  return useQuery(
    {
      queryKey: [FOOTPRINTING_CROP_DRYINGS, primaryDataId, isAdmin],
      queryFn: () => queryFn(primaryDataId ?? ""),
      enabled: !!primaryDataId,
      gcTime: 0,
    },
    queryClient
  );
};
